import { render } from "./App.vue?vue&type=template&id=e21bb968&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=e21bb968&lang=scss"

import exportComponent from "D:\\git\\tim\\tim-sign-ui_imza.ebirlik.net\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__